export const languageIcon = (language: string) => {
  if (language === 'es') {
    return 'https://flagcdn.com/es.svg';
  } else {
    return 'https://flagcdn.com/us.svg';
  }
};
